
define('inlineSvg!svgs/commercial/icon-location', function () {return '<span class="inline-icon-location inline-commercial"><svg width="7.1" height="13" viewBox="0 0 7.1 13"><path class="st0" d="M3.5 0C1.6 0 0 1.6 0 3.5 0 4 .1 4.6.3 5l2.9 8h.6l3-7.9c.2-.6.3-1.1.3-1.6C7.1 1.6 5.5 0 3.5 0m0 6.1C2.1 6.1 1 4.9 1 3.5 1 2.2 2.1 1 3.5 1S6 2.2 6 3.5c0 1.4-1.1 2.6-2.5 2.6"/></svg></span>';});

